import {ButtonHTMLAttributes, Ref} from 'react';

import {MenuAction} from './MenuAction';

interface MenuButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  ref?: Ref<HTMLButtonElement>;
}

export function MenuButton(props: MenuButtonProps) {
  return <MenuAction as="button" {...props} ref={props.ref} tabIndex={-1} />;
}
